export default __webpack_public_path__ + "static/media/dark3.b2356253.svg";